<template>
  <div class="ocr-page">
    <v-img alt="Logo" class="shrink mr-2 app ocr-logo" contain :src="logoimage" transition="scale-transition" />

    <v-sheet class="folded-corner ocr-panel">
      <v-container>
        <v-card elevation="0" class="ocr-card align-center pa-4 mx-auto">
          <header class="ocr-header">
            <h1>{{ "กรุณาถ่ายรูปบัตรยืนยันตัวตน" }}</h1>
            <p>{{ "Please take a photo of your ID card" }}</p>
            <span>{{ textAleart }}</span>
            <v-divider class="ocr-divider"></v-divider>
          </header>

          <div class="camera-stage">
            <div class="camera-container">
              <video v-show="!isPhotoTaken" ref="camera" autoplay></video>
              <div class="overlay-corner">
                <div></div>
              </div>
            </div>
          </div>

          <div class="ocr-actions">
            <v-card elevation="0" class="box white--text text-capitalize ocr-button" color="#344054"
              @click="BackToMain()" style="line-height:1.1">
              <span>{{ "ย้อนกลับ" }}</span>
              <small>{{ "BACK" }}</small>
            </v-card>

            <v-card id="downloadPhoto" elevation="0" class="box white--text text-capitalize ocr-button"
              color="#344054" :download="PictureName" @click="takePhoto1()" style="line-height:1.1">
              <span>{{ "ถ่ายรูป" }}</span>
              <small>{{ "TAKE A PHOTO" }}</small>
            </v-card>
          </div>
        </v-card>
      </v-container>
    </v-sheet>



    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <div class="loading-box">
        <div class="inter-load">
          <div class="rect rect1"></div>
          <div class="rect rect2"></div>
          <div class="rect rect3"></div>
          <div class="rect rect4"></div>
          <div class="rect rect5"></div>
        </div>
      </div>
    </v-dialog>


  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
// import logoimage from "@/assets/OneBangkokLogo.png";

// import ChangeLanguage from "@/components/ChangeLanguage";
export default {
  name: "OCR",
  components: {
    // ChangeLanguage,
  },
  data() {
    return {
      url: enurl.apiUrl,
      settingUrl: enurl.settingUrl,
      DefaultLogo: "@/assets/logo192.png",
      DefaultBG: "@/assets/1D2939.png",
      Datetime: "",
      timerCount: 30,
      isPhotoTaken: false,
      download: false,
      LoadingDialog: false,
      PictureName: "PersonID.jpg",
      dataParam: [],
      imageParam: "",
      photoBase64: "",
      logoimage: "",
      textAleart: "*กรุณาถ่ายบัตรให้อยู่ในกรอบ",
      imageCapture: null,
      count: 0,

      dataM: {
        documentNumber: "",
        prefixEN: "",
        firstnameEN: "Visitor",
        middlenameEN: "",
        lastnameEN: "Kiosk",
        sexEN: "",
        prefixTH: "",
        firstnameTH: "Visitor",
        middlenameTH: "",
        lastnameTH: "Kiosk",
        sexTH: "",
        type: "ID Card",
        image1: "",
        image2: "",
        tenantID: 0,
        towerID: 1,
        zoneID: 0,
        floorID: 0,
        locationID: 0,
      },

    };
  },

  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
            // if (this.timerCount % 3 == 0) {
            //   this.getDataPersonWithThaiSmartCard();
            // }
            // if (this.timerCount == 25) {
            //   this.skip();
            // }
            if (this.timerCount == 0) {
              // this.BackToMain();
            }
          }, 1000);
        }
      },
      immediate: true,
    },
  },

  mounted: function () {
    let self = this;


    // console.log(self.$route.params);
    self.dataParam = this.dataM;
    self.logoimage = require("@/assets/OneBangkokLogo.png");
    self.createCameraElement();
    // setInterval(() => {
    //   self.getCurrentDate();
    // }, 1000);
  },

  methods: {
    getCurrentDate() {
      let self = this;
      let newDate = new Date();
      let date =
        newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate();
      let month = newDate.getMonth() + 1;
      let year =
        newDate.getFullYear() < 2500
          ? newDate.getFullYear() + 543
          : newDate.getFullYear();
      let hours =
        newDate.getHours() < 10 ? "0" + newDate.getHours() : newDate.getHours();
      let minutes =
        newDate.getMinutes() < 10
          ? "0" + newDate.getMinutes()
          : newDate.getMinutes();
      let seconds =
        newDate.getSeconds() < 10
          ? "0" + newDate.getSeconds()
          : newDate.getSeconds();
      self.Datetime = `${date}/${month < 10 ? `0${month}` : `${month}`
        }/${year}  ${hours}:${minutes}:${seconds}`;
    },



    stopCameraStream() {

      if (this.$refs.camera.srcObject != null) {
        let tracks = this.$refs.camera.srcObject.getTracks();
        tracks.forEach((track) => {
          track.stop();
        });
      }


    },

    ocr() {
      let self = this;
      let temp = {
        image_data: this.dataParam.image1
      };
      axios
        .post(`${self.url}VMS/readOCR`, temp)
        .then(function (response) {

          if (response.status == 200) {

            if ((response.data.Englishname_firstname == null && response.data.Englishname_lastname == null) || response.data.Id == null ) {

              self.isPhotoTaken = false;
              self.textAleart = "*กรุณาถ่ายบัตรอีกครั้ง";
              //  self.$router.push({
              //   name: "CapturePerson",
              //   path: "/CapturePerson",
              //   params: {
              //     data: self.dataParam,
              //   },
              // });
              self.count++;
              if (self.count == 3) {
                // alert("ติดต่อพนักงาน");
                self.textAleart = "***กรุณาติดต่อพนักงาน***";
                setTimeout(() => {
                  self.BackToMain();
                }, 2000);

              }
            } else {

              
              response.data.Englishname_firstname = response.data.Englishname_firstname == null ? response.data.Englishname_firstname : response.data.Englishname_firstname.replace(/\s/g, '');
              response.data.Englishname_lastname = response.data.Englishname_lastname == null ? response.data.Englishname_lastname : response.data.Englishname_lastname.replace(/\s/g, '');
              response.data.Thainame_firstname = response.data.Thainame_firstname == null ? response.data.Thainame_firstname : response.data.Thainame_firstname.replace(/\s/g, '');
              response.data.Thainame_lastname = response.data.Thainame_lastname == null ? response.data.Thainame_lastname : response.data.Thainame_lastname.replace(/\s/g, '');


              self.dataParam.documentNumber = response.data.Id == null ? self.dataParam.documentNumber : response.data.Id;
              self.dataParam.firstnameEN = response.data.Englishname_firstname == null ? self.dataParam.firstnameEN : response.data.Englishname_firstname;
              self.dataParam.lastnameEN = response.data.Englishname_lastname == null ? self.dataParam.lastnameEN : response.data.Englishname_lastname;
              self.dataParam.firstnameTH = response.data.Thainame_firstname == null ? self.dataParam.firstnameTH : response.data.Thainame_firstname;
              self.dataParam.lastnameTH = response.data.Thainame_lastname == null ? self.dataParam.lastnameTH : response.data.Thainame_lastname;




              self.$router.push({
                name: "CapturePerson",
                path: "/CapturePerson",
                params: {
                  data: self.dataParam,
                },
              });
            }
            self.LoadingDialog = false
          }
        })
        .catch(function (error) {


            
          self.MessageAlert = error;
          alert(error.message);
          self.LoadingDialog = false
        });
    },

    createCameraElement() {
      const constraints = (window.constraints = {
        audio: false,
        video: true,
      });

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.$refs.camera.srcObject = stream;
          const track = stream.getVideoTracks()[0];

          const capabilities = track.getCapabilities();
          if (capabilities.focusMode && capabilities.focusDistance) {
            // console.log("กล้องรองรับการตั้งค่าโฟกัสด้วยตนเอง");

            const constraints = {
              advanced: [{
                focusMode: 'manual',
                focusDistance: 0.1
              }]
            };
            track.applyConstraints(constraints);
            //  alert("ตั้งค่าโฟกัสวัตถุระยะใกล้ (Macro) สำเร็จ");

          } else {
            // console.log("กล้องไม่รองรับการตั้งค่าโฟกัสระยะใกล้ด้วยตนเอง");
            // alert("กล้องไม่รองรับการตั้งค่าโฟกัสระยะใกล้ด้วยตนเอง");
          }

          this.imageCapture = new ImageCapture(track);
          console.log(this.imageCapture);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async takePhoto1() {
      let self = this;
      self.LoadingDialog = true;
      const blob = await this.imageCapture.takePhoto();
      // photo.value = URL.createObjectURL(blob);
      const base64 = await this.cropAndConvertToBase64(blob, 900, 900);


      this.isPhotoTaken = true;
      this.photoBase64 = base64;
      this.dataParam.image1 = base64.split(",")[1];
      this.ocr();


      // console.log(blob);
    },

    async cropAndConvertToBase64(blob, cropTop = 0, cropBottom = 0) {
      const imageBitmap = await createImageBitmap(blob);
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      // คำนวณขนาดภาพที่เหลือหลังตัด
      const cropHeight = imageBitmap.height - cropTop - cropBottom;

      // ตั้งขนาด canvas ใหม่
      canvas.width = imageBitmap.width;
      canvas.height = cropHeight;

      // วาดภาพเฉพาะส่วนที่ต้องการ (เริ่มจาก cropTop ลงมา)
      ctx.drawImage(
        imageBitmap,
        0, cropTop, imageBitmap.width, cropHeight, // ส่วนที่ตัดจากต้นฉบับ
        0, 0, imageBitmap.width, cropHeight        // วาดลงบน canvas
      );

      // แปลง canvas → base64
      return canvas.toDataURL("image/jpeg", 0.8); // 0.9 = คุณภาพ
    },

    blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result); // ผลลัพธ์จะเป็น Base64 string
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    },

    takePhoto() {
      let self = this;
      self.isShotPhoto = true;
      self.LoadingDialog = true;
      const FLASH_TIMEOUT = 50;


      const videoElement = self.$refs.camera;
      const canvasElement = self.$refs.canvas;
      const context = canvasElement.getContext("2d");

      canvasElement.width = videoElement.videoWidth;
      canvasElement.height = videoElement.videoHeight;
      context.drawImage(
        videoElement,
        -180, -650,
        1080,
        1980
      );

      setTimeout(() => {
        self.isShotPhoto = false;
        self.GotoFindingTenant();
        // this.downloadImage();
      }, FLASH_TIMEOUT);

    },

    downloadImage() {
      const canvas = document
        .getElementById("photoTaken")
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream");
      if (canvas) {
        canvas.focus();
      }
      this.isPhotoTaken = true;
      this.imageParam = canvas;
      this.dataParam.image1 = this.imageParam.split(",")[1];
      // this.ocr();

    },

    GotoFindingTenant() {
      let self = this;
      self.downloadImage();
      self.stopCameraStream();
      // self.$router.push("/FindingTenant");


      // self.$router.push({
      //   name: "CapturePerson",
      //   path: "/CapturePerson",
      //   params: {
      //     data: self.dataParam,
      //   },
      // });

    },

    BackToMain() {
      let self = this;
      self.$router.push("/MainMenu");
    },

    BacktoNationalIDCard() {
      let self = this;
      self.stopCameraStream();
      self.$router.push("/NationalIDCard");
    },

    CapturePerson() {
      let self = this;
      self.$router.push("/CapturePerson");
    },
  },
};
</script>
<style scoped>
.ocr-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: clamp(14px, 2vh, 24px);
  padding: clamp(18px, 3vw, 40px);
}

.ocr-page .ocr-logo {
  width: min(28vw, 430px) !important;
  max-width: min(28vw, 430px) !important;
  margin: 0 !important;
}

.ocr-page .ocr-panel {
  width: min(1060px, calc(100vw - 160px)) !important;
  min-height: 0 !important;
  max-height: calc(100vh - 160px);
  margin: 0 auto !important;
  padding: clamp(18px, 2.4vw, 34px) !important;
}

.ocr-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(14px, 2vh, 22px);
}

.ocr-header {
  text-align: center;
}

.ocr-header h1 {
  color: #344054;
  font-size: clamp(34px, 3.2vw, 56px);
  font-weight: 800;
  line-height: 1.1;
  margin: 0;
}

.ocr-header p {
  color: #667085;
  font-size: clamp(22px, 2vw, 34px);
  font-weight: 700;
  line-height: 1.2;
  margin: 8px 0 0;
}

.ocr-header span {
  display: block;
  color: #e11d48;
  font-size: clamp(16px, 1.1vw, 20px);
  font-weight: 800;
  margin-top: 14px;
}

.ocr-divider {
  width: min(520px, 44vw);
  margin: 14px auto 0;
  border-top-width: 7px !important;
  border-color: #344054 !important;
}

.camera-stage {
  display: flex;
  justify-content: center;
  width: 100%;
}

.ocr-page .camera-container {
  width: min(48vw, 650px) !important;
  height: min(34vh, 360px) !important;
  min-height: 280px;
}

.ocr-page video {
  width: 100% !important;
  height: 100% !important;
}

.ocr-actions {
  width: min(760px, 100%);
  display: grid;
  grid-template-columns: repeat(2, minmax(220px, 1fr));
  gap: clamp(22px, 4vw, 56px);
}

.ocr-button {
  width: 100% !important;
  min-height: 86px !important;
  background-color: #344054 !important;
}

.ocr-button span {
  font-size: clamp(30px, 2.8vw, 44px);
  font-weight: 800;
}

.ocr-button small {
  font-size: clamp(16px, 1.3vw, 24px);
  font-weight: 700;
}

@media all and (orientation: portrait) {
  .fullscreen {
    height: 1890px;
  }
}

@media all and (orientation: landscape) {
  .fullscreen {
    height: auto;
  }
}

.camera-container {
  position: relative;
  width: 640px;
  height: 480px;
}

video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}

.overlay-hole {
  /* ทำให้ครอบคลุมทั้งหน้าจอและอยู่เหนือองค์ประกอบอื่น */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  
  /* ให้มีสีพื้นหลังที่ต้องการจะบัง (เช่น สีดำโปร่งใส) */
  background-color: rgba(0, 0, 0, 0.6); /* 60% ความทึบ */
  
  /* เปิดใช้งานการตัดของ overlay */
  pointer-events: none;
  
  /* ใช้ Mask/Clip-path เพื่อตัด "รู" */
  /* ตำแหน่งของรู: 15% จากซ้าย, 15% จากบน, กว้าง 70%, สูง 70% */
  -webkit-mask: 
      /* ส่วนที่มองเห็นทะลุ: สี่เหลี่ยมโปร่งใส */
      radial-gradient(
          circle at 50% 50%, 
          transparent 0, 
          transparent 35vh, 
          black 35vh
      );
  mask: 
      /* ส่วนที่มองเห็นทะลุ: สี่เหลี่ยมโปร่งใส */
      radial-gradient(
          circle at 50% 50%, 
          transparent 0, 
          transparent 35vh, 
          black 35vh
      );
  
  /* ใช้ border-radius และตำแหน่งที่คุณกำหนดไว้ (เป็นเพียงกรอบแสดงตำแหน่ง) */
  /* คุณอาจไม่จำเป็นต้องใช้โค้ดนี้หากใช้ .overlay-hole */
  /* แต่นี่คือวิธีที่ใช้ box-shadow เพื่อสร้าง "รู" */
  /* ****************************************************** */
  
  /* วิธีที่ง่ายกว่าคือใช้ box-shadow กับ pseudo-element */
  /* ยกเลิก mask/clip-path ด้านบน แล้วใช้โค้ดด้านล่างแทน */
}

/* === Overlay สี่เหลี่ยมเต็ม (ถ่ายบัตรประชาชน) === */
.overlay-full {
  position: absolute;
  top: 15%;
  left: 15%;
  width: 70%;
  height: 70%;
  border: 20px solid #787c78;
  border-radius: 10px;
  pointer-events: none;
}


.overlay-full::before {
  /* ใช้โค้ดนี้กับ overlay-full เดิม */
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  pointer-events: auto; 
  z-index: 5;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.6); 
  
  /* ทำให้เงาอยู่ใต้กรอบ border */
  mix-blend-mode: multiply;
}

/* === Overlay แบบมุม (สแกน QR) === */
.overlay-corner {
  position: absolute;
  top: 20%;
  left: 15%;
  width: 70%;
  height: 60%;
  pointer-events: none;
}

.overlay-corner::before,
.overlay-corner::after,
.overlay-corner div::before,
.overlay-corner div::after {
  content: "";
  position: absolute;
  width: 50px;
  height: 50px;
  border: 10px solid #00ff00;
}

/* มุมซ้ายบน */
.overlay-corner::before {
  top: 0;
  left: 0;
  border-right: none;
  border-bottom: none;
}

/* มุมขวาบน */
.overlay-corner::after {
  top: 0;
  right: 0;
  border-left: none;
  border-bottom: none;
}

/* มุมซ้ายล่าง */
.overlay-corner div::before {
  bottom: 0;
  left: 0;
  border-right: none;
  border-top: none;
}

/* มุมขวาล่าง */
.overlay-corner div::after {
  bottom: 0;
  right: 0;
  border-left: none;
  border-top: none;
}

/* HTML: <div class="loader"></div> */
.loader {
  width: 60px;
  aspect-ratio: .5;
  display: grid;
}

.loader:before {
  content: "";
  width: 30%;
  aspect-ratio: 1;
  border-radius: 50%;
  margin: auto auto 0;
  background: #CF4647;
  animation: l9-0 .5s cubic-bezier(0, 800, 1, 800) infinite;
}

.loader:after {
  content: "";
  width: 100%;
  aspect-ratio: 1/cos(30deg);
  margin: 0 auto auto;
  clip-path: polygon(50% -50%, 100% 50%, 50% 150%, 0 50%);
  background: #524656;
  animation: l9-1 .5s linear infinite;
}

@keyframes l9-0 {

  0%,
  2% {
    translate: 0 0%
  }

  98%,
  to {
    translate: 0 -.2%
  }
}

@keyframes l9-1 {

  0%,
  5% {
    rotate: 0deg
  }

  95%,
  to {
    rotate: -60deg
  }
}
</style>
